<template>
  <div class="main-wrapper">
    <p>
      <span
        :class="
          NO_INTERNATIONAL_FACES ||
          INTERNATIONAL_BENEFICIARY ||
          INTERNATIONAL_RELATIVE
            ? 'valid-field'
            : 'unvalid-field'
        "
        >➤</span
      >
      {{
        !isIP
          ? "Принадлежат ли бенефициары организации"
          : "Принадлежит ли индивидуальный предприниматель или его бенефициарный владелец"
      }}

      и/или родственник (супруг, супруга, отец, мать, сын, дочь, дедушка,
      бабушка, внук, полнородный и неполнородный (имеющий общих отца или мать)
      брат, сестра, усыновитель, усыновленный)
      {{
        !isIP
          ? "бенефициара организации"
          : "индивидуального предпринимателя или его бенефициарного владельца"
      }}
      к иностранным публичным должностным лицам (ИПДЛ) и/или должностным лицам
      публичных международных организаций (МПДЛ) и/или к лицам, замещающим
      (занимающим) государственные должности РФ, должности членов Совета
      директоров ЦБ РФ, должности федеральной государственной службы, назначение
      на которые и освобождение от которых осуществляются Президентом РФ или
      Правительством РФ, должности в ЦБ РФ, государственных корпорациях и иных
      организациях, созданных Российской Федерацией на основании федеральных
      законов, включенные в перечни должностей, определяемые Президентом РФ
      (РПДЛ)
    </p>
    <div class="main-checkboxes">
      <label>
        <input
          type="checkbox"
          v-model="NO_INTERNATIONAL_FACES"
          @click="
            INTERNATIONAL_BENEFICIARY = false;
            INTERNATIONAL_RELATIVE = false;
            international_faces = [];
            relativeLevel = '';
          "
          :disabled="
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('INTERNATIONAL_BENEFICIARY') != -1) ||
              (pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('INTERNATIONAL_RELATIVE') != -1)
          "
        />НЕТ
      </label>
      <label>
        <input
          type="checkbox"
          v-model="INTERNATIONAL_RELATIVE"
          @click="
            NO_INTERNATIONAL_FACES = false;
            relativeLevel = '';
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('INTERNATIONAL_RELATIVE') != -1
          "
        />ДА, принадлежит родственник
      </label>
      <p v-if="INTERNATIONAL_RELATIVE">
        <input
          type="text"
          placeholder="Укажите степень родства ПДЛ"
          class="input-line"
          v-model="relativeLevel"
          @input="
            relativeLevel != null && relativeLevel > 80
              ? (relativeLevel = relativeLevel.substr(0, 80))
              : relativeLevel
          "
        />
      </p>
      <label>
        <input
          type="checkbox"
          v-model="INTERNATIONAL_BENEFICIARY"
          @click="
            NO_INTERNATIONAL_FACES = false;
            international_faces = [];
            international_faces.push({
              id: international_faces.length + 1,
              valid: true,
              INTER_FIO: '',
              INTER_TYPE: 'ИПДЛ',
              INTER_POSITION: '',
              INTER_ORG_NAME: '',
              INTER_ORG_ADDRESS: '',
            });
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('INTERNATIONAL_BENEFICIARY') != -1
          "
        />{{
          isIP
            ? "ДА, принадлежит индивидуальный предприниматель или его бенефициарный владелец"
            : "ДА, принадлежит бенефициар"
        }}
      </label>
    </div>
    <p
      v-if="INTERNATIONAL_BENEFICIARY && getValidInternationalFaces() < 1"
      class="center-text-nes"
    >
      Заполните хотя бы 1 строку таблицы
    </p>
    <table v-if="INTERNATIONAL_BENEFICIARY" class="afa-table">
      <tr>
        <td class="afa-td"></td>
        <td class="afa-td">
          {{ !isIP ? "ФИО бенефициара" : "ФИО" }}
        </td>
        <td class="afa-td">Тип</td>
        <td class="afa-td">Должность</td>
        <td class="afa-td">Наименование организации</td>
        <td class="afa-td">Адрес организации</td>
      </tr>
      <tr v-for="face in international_faces" :key="face.id">
        <td class="afa-td">
          <span :class="face.valid ? 'valid-field' : 'unvalid-field'">➤</span>
        </td>
        <td class="afa-td">
          <textarea
            type="text"
            class="input-line-textarea"
            v-model="face.INTER_FIO"
            @input="
              face.INTER_FIO.length > 255
                ? face.INTER_FIO.substr(0, 255)
                : face.INTER_FIO;
              checkInterFace(face);
            "
          />
        </td>
        <td class="afa-td">
          <dropdown
            :options="benefsType"
            :selected="{ name: face.INTER_TYPE }"
            placeholder="Укажите тип"
            v-on:updateOption="
              face.INTER_TYPE = $event.name;
              checkInterFace(face);
              $forceUpdate();
            "
          ></dropdown>
        </td>
        <td class="afa-td">
          <textarea
            type="text"
            class="input-line-textarea"
            v-model="face.INTER_POSITION"
            @input="
              face.INTER_POSITION.length > 255
                ? face.INTER_POSITION.substr(0, 255)
                : face.INTER_POSITION;
              checkInterFace(face);
            "
          />
        </td>
        <td class="afa-td">
          <textarea
            type="text"
            class="input-line-textarea"
            v-model="face.INTER_ORG_NAME"
            @input="
              face.INTER_ORG_NAME.length > 255
                ? face.INTER_ORG_NAME.substr(0, 255)
                : face.INTER_ORG_NAME;
              checkInterFace(face);
            "
          />
        </td>
        <td class="afa-td">
          <textarea
            type="text"
            class="input-line-textarea"
            v-model="face.INTER_ORG_ADDRESS"
            @input="
              face.INTER_ORG_ADDRESS.length > 1000
                ? face.INTER_ORG_ADDRESS.substr(0, 1000)
                : face.INTER_ORG_ADDRESS;
              checkInterFace(face);
            "
          />
        </td>
      </tr>
    </table>

    <p>
      <span
        :class="
          doInBenefitsForFace[0] ||
          doInBenefitsForFace[1] ||
          doInBenefitsForFace[2] ||
          doInBenefitsForFace[3] ||
          doInBenefitsForFace[4] ||
          doInBenefitsForFace[5]
            ? 'valid-field'
            : 'unvalid-field'
        "
        >➤</span
      >
      Действует ли
      {{ !isIP ? "организация" : "индивидуальный предприниматель" }} к выгоде
      иного лица – выгодоприобретателя (Выгодоприобретатель – лицо (структура
      без образования юридического лица), к выгоде которого действует клиент, в
      том числе на основании агентского договора, договора поручения, договора
      комиссии и договора доверительного управления)
    </p>
    <div class="main-checkboxes">
      <label>
        <input
          type="checkbox"
          v-model="doInBenefitsForFace[0]"
          :disabled="isAnotherFaceRequired"
          @click="
            doInBenefitsForFace = [
              doInBenefitsForFace[0],
              false,
              false,
              false,
              false,
              false,
            ];
            infoEn = [{ id: 0, FACT_ADDRESS: '' }];
            infoEnNo = [{ id: 0 }];
            infoInd = [
              {
                id: 0,
                DUL_DOCTYPE: 'Паспорт гражданина РФ',
                FACT_ADDRESS: '',
                POST_ADDRESS: '',
                REG_ADDRESS: '',
              },
            ];
            infoIP = [
              {
                id: 0,
                DUL_DOCTYPE: 'Паспорт гражданина РФ',
                FACT_ADDRESS: '',
                POST_ADDRESS: '',
                REG_ADDRESS: '',
              },
            ];
            infoIndNo = [
              {
                id: 0,
                DUL_DOCTYPE: 'Паспорт гражданина РФ',
                FACT_ADDRESS: '',
                POST_ADDRESS: '',
                REG_ADDRESS: '',
              },
            ];
          "
        />НЕТ
      </label>
      <label>
        <input
          type="checkbox"
          v-model="doInBenefitsForFace[1]"
          @click="
            doInBenefitsForFace[0] = false;
            infoInd = [
              {
                id: 0,
                DUL_DOCTYPE: 'Паспорт гражданина РФ',
                FACT_ADDRESS: '',
                POST_ADDRESS: '',
                REG_ADDRESS: '',
              },
            ];
          "
        />ДА, физического лица – резидента
      </label>
      <div v-if="doInBenefitsForFace[1]">
        <div class="face-table" v-for="info in infoInd" :key="info.id">
          <p class="necessary-table-center">
            Корректно заполните все выделенные поля.
          </p>
          <IndividualsFounderInfo
            @updated="updated"
            :info="info"
            :url="url"
            v-if="doInBenefitsForFace[1]"
          />
        </div>
        <div
          class="add-button"
          @click="
            infoInd.push({
              id: infoInd.length,
              DUL_DOCTYPE: 'Паспорт гражданина РФ',
              FACT_ADDRESS: '',
              POST_ADDRESS: '',
              REG_ADDRESS: '',
            })
          "
        >
          <div class="icons">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <p>Добавить ещё одно физическое лицо – резидент</p>
          </div>
        </div>
      </div>
      <label>
        <input
          type="checkbox"
          v-model="doInBenefitsForFace[5]"
          @click="
            doInBenefitsForFace[0] = false;
            infoIndNo = [
              {
                id: 0,
                DUL_DOCTYPE: 'Паспорт гражданина РФ',
                FACT_ADDRESS: '',
                POST_ADDRESS: '',
                REG_ADDRESS: '',
              },
            ];
          "
        />ДА, физического лица – нерезидента или лица без гражданства
      </label>
      <div v-if="doInBenefitsForFace[5]">
        <div class="face-table" v-for="info in infoIndNo" :key="info.id">
          <p class="necessary-table-center">
            Корректно заполните все выделенные поля.
          </p>
          <FacesIndividualNoTable
            @updated="updated"
            :info="info"
            :url="url"
            v-if="doInBenefitsForFace[5]"
          />
        </div>
        <div
          class="add-button"
          @click="
            infoIndNo.push({
              id: infoIndNo.length,
              DUL_DOCTYPE: 'Паспорт гражданина РФ',
              FACT_ADDRESS: '',
              POST_ADDRESS: '',
              REG_ADDRESS: '',
            })
          "
        >
          <div class="icons">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <p>Добавить ещё одно физическое лицо – нерезидент</p>
          </div>
        </div>
      </div>
      <label>
        <input
          type="checkbox"
          v-model="doInBenefitsForFace[2]"
          @click="
            doInBenefitsForFace[0] = false;
            infoEn = [{ id: 0, FACT_ADDRESS: '' }];
          "
        />ДА, юридического лица – резидента
      </label>
      <div v-if="doInBenefitsForFace[2]">
        <div class="face-table" v-for="info in infoEn" :key="info.id">
          <p class="necessary-table-center">
            Корректно заполните все выделенные поля.
          </p>
          <FacesEntityTable
            @updated="updated"
            :info="info"
            :url="url"
            v-if="doInBenefitsForFace[2]"
          />
        </div>
        <div
          class="add-button"
          @click="infoEn.push({ id: infoEn.length, FACT_ADDRESS: '' })"
        >
          <div class="icons">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <p>Добавить ещё одно юридическое лицо – резидент</p>
          </div>
        </div>
      </div>
      <label>
        <input
          type="checkbox"
          v-model="doInBenefitsForFace[4]"
          @click="
            doInBenefitsForFace[0] = false;
            infoEnNo = [{ id: 0 }];
          "
        />ДА, юридического лица – нерезидента
      </label>
      <div v-if="doInBenefitsForFace[4]">
        <div class="face-table" v-for="info in infoEnNo" :key="info.id">
          <p class="necessary-table-center">
            Корректно заполните все выделенные поля.
          </p>
          <FacesEntityNoTable
            @updated="updated"
            :info="info"
            :url="url"
            v-if="doInBenefitsForFace[4]"
          />
        </div>
        <div class="add-button" @click="infoEnNo.push({ id: infoEnNo.length })">
          <div class="icons">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <p>Добавить ещё одно юридическое лицо – нерезидент</p>
          </div>
        </div>
      </div>
      <label>
        <input
          type="checkbox"
          v-model="doInBenefitsForFace[3]"
          @click="
            doInBenefitsForFace[0] = false;
            infoIP = [
              {
                id: 0,
                DUL_DOCTYPE: 'Паспорт гражданина РФ',
                FACT_ADDRESS: '',
                POST_ADDRESS: '',
                REG_ADDRESS: '',
              },
            ];
          "
        />ДА, индивидуального предпринимателя, физического лица, занимающегося в
        установленном законодательством порядке частной практикой
      </label>
    </div>
    <div v-if="doInBenefitsForFace[3]">
      <div class="face-table" v-for="info in infoIP" :key="info.id">
        <p class="necessary-table-center">
          Корректно заполните все выделенные поля.
        </p>
        <FacesIPTable
          @updated="updated"
          :info="info"
          :url="url"
          v-if="doInBenefitsForFace[3]"
        />
      </div>
      <div
        class="add-button"
        @click="
          infoIP.push({
            id: infoIP.length,
            DUL_DOCTYPE: 'Паспорт гражданина РФ',
            FACT_ADDRESS: '',
            POST_ADDRESS: '',
            REG_ADDRESS: '',
          })
        "
      >
        <div class="icons">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <p>Добавить ещё одного индивидуального предпринимателя</p>
        </div>
      </div>
    </div>
    <div class="empty-space" v-if="doInBenefitsForFace[3]"></div>
  </div>
</template>

<script>
import IndividualsFounderInfo from "./v-another-faces-individual.vue";
import FacesIndividualNoTable from "./v-another-faces-ind-no.vue";
import FacesIPTable from "./v-another faces-ip.vue";
import FacesEntityTable from "./v-another-faces-entity.vue";
import FacesEntityNoTable from "./v-another-faces-entity-no.vue";

import dropdown from "vue-dropdowns";
import dateConverter from "../utils/date-converter.js";

export default {
  name: "AnotherFacesAgree",
  props: {
    pageInfo: {},
    url: String,
    pageName: String,
    isIP: Boolean,
  },
  components: {
    IndividualsFounderInfo,
    FacesIPTable,
    FacesEntityTable,
    FacesEntityNoTable,
    FacesIndividualNoTable,
    dropdown,
  },
  data: () => ({
    doInBenefitsForFace: [false, false, false, false, false, false],
    infoIP: [{ id: 0, DUL_DOCTYPE: "Паспорт гражданина РФ" }],
    infoEn: [{ id: 0 }],
    infoInd: [{ id: 0, DUL_DOCTYPE: "Паспорт гражданина РФ" }],
    infoEnNo: [{ id: 0 }],
    infoIndNo: [{ id: 0, DUL_DOCTYPE: "Паспорт гражданина РФ" }],
    INTERNATIONAL_RELATIVE: false,
    INTERNATIONAL_BENEFICIARY: false,
    NO_INTERNATIONAL_FACES: false,
    international_faces: [],
    isAnotherFaceRequired: false,
    sendData: {},
    relativeLevel: "",
    benefsType: [
      {
        name: "ИПДЛ",
      },
      {
        name: "МПДЛ",
      },
      {
        name: "РПДЛ",
      },
    ],
  }),
  methods: {
    updated() {
      this.validation();
      this.$emit("updated");
    },
    checkInterFace(face) {
      face.valid =
        (face.INTER_FIO != null &&
          face.INTER_FIO.length > 0 &&
          face.INTER_TYPE != null &&
          face.INTER_POSITION != null &&
          face.INTER_POSITION.length > 0 &&
          face.INTER_ORG_NAME != null &&
          face.INTER_ORG_NAME.length > 0 &&
          face.INTER_ORG_ADDRESS != null &&
          face.INTER_ORG_ADDRESS.length > 0) ||
        ((face.INTER_FIO == null || face.INTER_FIO.length == 0) &&
          (face.INTER_POSITION == null || face.INTER_POSITION.length == 0) &&
          (face.INTER_ORG_NAME == null || face.INTER_ORG_NAME.length == 0) &&
          (face.INTER_ORG_ADDRESS == null ||
            face.INTER_ORG_ADDRESS.length == 0));
      if (
        face.valid &&
        face.INTER_FIO != null &&
        face.INTER_FIO.length > 0 &&
        face.id == this.international_faces.length
      )
        this.international_faces.push({
          id: this.international_faces.length + 1,
          valid: true,
          INTER_FIO: "",
          INTER_TYPE: "ИПДЛ",
          INTER_POSITION: "",
          INTER_ORG_NAME: "",
          INTER_ORG_ADDRESS: "",
        });
    },
    getValidInternationalFaces() {
      let a = 0;
      this.international_faces.forEach((e) =>
        e.valid && e.INTER_FIO != null && e.INTER_FIO.length > 0 ? a++ : a
      );
      return a;
    },
    validation() {
      var msg = "";
      if (
        !this.NO_INTERNATIONAL_FACES &&
        !this.INTERNATIONAL_RELATIVE &&
        !this.INTERNATIONAL_BENEFICIARY
      ) {
        if (!this.isIP)
          msg +=
            msg.length == 0
              ? "Необходимо заполнить поля:<br>• Принадлежит ли индивидуальный предприниматель или его бенефициарный владелец и/или родственник<br>"
              : "• Принадлежит ли индивидуальный предприниматель или его бенефициарный владелец и/или родственник<br>";
        else
          msg +=
            msg.length == 0
              ? "Необходимо заполнить поля:<br>• Принадлежат ли бенефициары организации и/или родственник<br>"
              : "• Принадлежат ли бенефициары организации и/или родственник<br>";
      }
      if (this.INTERNATIONAL_RELATIVE && this.relativeLevel.length == 0)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Степень родства<br>"
            : "• Степень родства<br>";
      if (
        this.INTERNATIONAL_BENEFICIARY &&
        this.getValidInternationalFaces() < 1
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Заполните хотя бы 1 строку таблицы о принадлежности бенефициаров и/или родственников<br>"
            : "• Заполните хотя бы 1 строку таблицы о принадлежности бенефициаров и/или родственников<br>";
      if (
        !(
          this.doInBenefitsForFace[0] ||
          this.doInBenefitsForFace[1] ||
          this.doInBenefitsForFace[2] ||
          this.doInBenefitsForFace[3] ||
          this.doInBenefitsForFace[4] ||
          this.doInBenefitsForFace[5]
        ) &&
        !this.isIP
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>•  Действует ли организация к выгоде иного лица – выгодоприобретателя<br>"
            : "•  Действует ли организация к выгоде иного лица – выгодоприобретателя<br>";
      if (
        this.isAnotherFaceRequired &&
        !(
          this.doInBenefitsForFace[1] ||
          this.doInBenefitsForFace[2] ||
          this.doInBenefitsForFace[3] ||
          this.doInBenefitsForFace[4] ||
          this.doInBenefitsForFace[5]
        )
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>•  Добавьте хотя бы одного выгодопреобретателя<br>"
            : "•  Добавьте хотя бы одного выгодопреобретателя<br>";
      if (
        !(
          this.doInBenefitsForFace[0] ||
          this.doInBenefitsForFace[1] ||
          this.doInBenefitsForFace[2] ||
          this.doInBenefitsForFace[3] ||
          this.doInBenefitsForFace[4] ||
          this.doInBenefitsForFace[5]
        ) &&
        this.isIP
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>•  Действует ли индивидуальный предприниматель к выгоде иного лица – выгодоприобретателя<br>"
            : "•  Действует ли индивидуальный предприниматель к выгоде иного лица – выгодоприобретателя<br>";
      if (this.doInBenefitsForFace[1] && !this.checkInd())
        msg += "Корректно заполните данные (физическое лицо – резидент)<br>";
      if (this.doInBenefitsForFace[5] && !this.checkIndNo())
        msg += "Корректно заполните данные (физическое лицо – нерезидент)<br>";
      if (this.doInBenefitsForFace[2] && !this.checkEntity())
        msg += "Корректно заполните данные (юридическое лицо – резидент)<br>";
      if (this.doInBenefitsForFace[4] && !this.checkEntityNo())
        msg += "Корректно заполните данные (юридическое лицо – нерезидент)<br>";
      if (this.doInBenefitsForFace[3] && !this.checkIP())
        msg +=
          "Корректно заполните данные (индвивидуальный предприниматель)<br>";

      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.createSendData();
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
    createSendData() {
      this.sendData.DO_ACTS_FOR_HIDDEN_RULER = !this.doInBenefitsForFace[0];
      this.sendData.IS_ANOTHER_BENEF_PERSON = this.doInBenefitsForFace[1];
      this.sendData.IS_ANOTHER_BENEF_UL = this.doInBenefitsForFace[2];
      this.sendData.IS_ANOTHER_BENEF_IP = this.doInBenefitsForFace[3];
      this.sendData.INTERNATIONAL_RELATIVE = this.INTERNATIONAL_RELATIVE;
      this.sendData.INTERNATIONAL_BENEFICIARY = this.INTERNATIONAL_BENEFICIARY;
      this.sendData.PDMAN_SIBLING = this.relativeLevel;
      if (
        this.sendData.INTERNATIONAL_RELATIVE ||
        this.sendData.INTERNATIONAL_BENEFICIARY
      ) {
        this.sendData.QUEST_BENEF_INTERN_FACES = [];
        this.international_faces.forEach((e) => {
          if (e.valid && e.INTER_FIO && e.INTER_FIO.length > 0)
            this.sendData.QUEST_BENEF_INTERN_FACES.push(e);
        });
      } else {
        delete this.sendData.QUEST_BENEF_INTERN_FACES;
      }
      if (this.doInBenefitsForFace[1] && this.doInBenefitsForFace[3]) {
        this.sendData.PERSONS = this.infoInd.concat(this.infoIP);
      } else {
        if (this.doInBenefitsForFace[3]) {
          this.sendData.PERSONS = this.infoIP;
        } else if (this.doInBenefitsForFace[1]) {
          this.sendData.PERSONS = this.infoInd;
        }
      }
      if (this.doInBenefitsForFace[2]) {
        this.sendData.ORGS = this.infoEn;
      }

      if (this.doInBenefitsForFace[4]) {
        this.sendData.FOREIGN_ORGS = this.infoEnNo;
      }
      if (this.doInBenefitsForFace[5]) {
        this.sendData.FOREIGN_PERSONS = this.infoIndNo;
      }
    },
    checkIP() {
      var a = true;
      if (this.doInBenefitsForFace[3]) {
        this.infoIP.forEach((item) => {
          a = a && item.valid != null && item.valid;
        });
      }
      return a;
    },
    checkEntity() {
      var a = true;
      if (this.doInBenefitsForFace[2]) {
        this.infoEn.forEach((item) => {
          a = a && item.valid != null && item.valid;
        });
      }
      return a;
    },
    checkEntityNo() {
      var a = true;
      if (this.doInBenefitsForFace[4]) {
        this.infoEnNo.forEach((item) => {
          a = a && item.valid != null && item.valid;
        });
      }
      return a;
    },
    checkInd() {
      var a = true;
      if (this.doInBenefitsForFace[1]) {
        this.infoInd.forEach((item) => {
          a = a && item.valid != null && item.valid;
        });
      }
      return a;
    },
    checkIndNo() {
      var a = true;
      if (this.doInBenefitsForFace[5]) {
        this.infoIndNo.forEach((item) => {
          a = a && item.valid != null && item.valid;
        });
      }
      return a;
    },
  },
  async created() {
    try {
      if (this.pageInfo.QUEST_BENEF_INTERN_FACES != null) {
        this.pageInfo.QUEST_BENEF_INTERN_FACES.forEach((e) => {
          this.checkInterFace(e);
          this.international_faces.push(e);
        });
        if (this.international_faces.length > 0)
          this.international_faces.push({
            id: this.international_faces.length + 1,
            valid: true,
            INTER_FIO: "",
            INTER_TYPE: "ИПДЛ",
            INTER_POSITION: "",
            INTER_ORG_NAME: "",
            INTER_ORG_ADDRESS: "",
          });
      }
      if (this.pageInfo.NEED_ANOTHER_BENEFIT != null)
        this.isAnotherFaceRequired = this.pageInfo.NEED_ANOTHER_BENEFIT;
      if (this.pageInfo.INTERNATIONAL_RELATIVE != null)
        this.INTERNATIONAL_RELATIVE = this.pageInfo.INTERNATIONAL_RELATIVE;
      if (this.pageInfo.INTERNATIONAL_BENEFICIARY != null)
        this.INTERNATIONAL_BENEFICIARY = this.pageInfo.INTERNATIONAL_BENEFICIARY;
      if (
        this.pageInfo.INTERNATIONAL_BENEFICIARY != null &&
        this.pageInfo.INTERNATIONAL_RELATIVE != null
      ) {
        this.NO_INTERNATIONAL_FACES = !(
          this.pageInfo.INTERNATIONAL_BENEFICIARY ||
          this.pageInfo.INTERNATIONAL_RELATIVE
        );
      }
      if (this.pageInfo.PDMAN_SIBLING != null)
        this.relativeLevel = this.pageInfo.PDMAN_SIBLING;
      if (this.pageInfo.NO_NON_RUSSIAN_TAX != null)
        this.taxResidentAnother = [
          this.pageInfo.NO_NON_RUSSIAN_TAX,
          !this.pageInfo.NO_NON_RUSSIAN_TAX,
        ];
      if (this.pageInfo.DO_ACTS_FOR_HIDDEN_RULER != null)
        this.doInBenefitsForFace[0] = !this.pageInfo.DO_ACTS_FOR_HIDDEN_RULER;
      if (this.pageInfo.NO_FOREIGN_CONTROLLERS != null)
        this.noControlFace = [
          this.pageInfo.NO_FOREIGN_CONTROLLERS,
          !this.pageInfo.NO_FOREIGN_CONTROLLERS,
        ];
      if (this.pageInfo.PERSONS != null && this.pageInfo.PERSONS.length > 0) {
        this.infoIP = [];
        this.infoInd = [];
        this.pageInfo.PERSONS.forEach((item) => {
          if (item.OGRNIP != null) {
            item.id = this.infoIP.length;
            if (item.DUL_DOCTYPE == null)
              item.DUL_DOCTYPE = "Паспорт гражданина РФ";
            if (item.BIRTH_DATE != null && item.BIRTH_DATE.indexOf("-") != -1)
              item.BIRTH_DATE = dateConverter.fromServerConvert(
                item.BIRTH_DATE
              );
            if (item.DUL_DATE != null && item.DUL_DATE.indexOf("-") != -1)
              item.DUL_DATE = dateConverter.fromServerConvert(item.DUL_DATE);
            if (item.DOC_DATE != null && item.DOC_DATE.indexOf("-") != -1)
              item.DOC_DATE = dateConverter.fromServerConvert(item.DOC_DATE);
            if (item.OGRNIP_DATE != null && item.OGRNIP_DATE.indexOf("-") != -1)
              item.OGRNIP_DATE = dateConverter.fromServerConvert(
                item.OGRNIP_DATE
              );
            this.infoIP.push(item);
            this.doInBenefitsForFace[3] = true;
          } else {
            item.id = this.infoInd.length;
            if (item.DUL_DOCTYPE == null)
              item.DUL_DOCTYPE = "Паспорт гражданина РФ";
            if (item.BIRTH_DATE != null && item.BIRTH_DATE.indexOf("-") != -1)
              item.BIRTH_DATE = dateConverter.fromServerConvert(
                item.BIRTH_DATE
              );
            if (item.DUL_DATE != null && item.DUL_DATE.indexOf("-") != -1)
              item.DUL_DATE = dateConverter.fromServerConvert(item.DUL_DATE);
            if (item.DOC_DATE != null && item.DOC_DATE.indexOf("-") != -1)
              item.DOC_DATE = dateConverter.fromServerConvert(item.DOC_DATE);
            this.infoInd.push(item);
            this.doInBenefitsForFace[1] = true;
          }
        });
      }
      if (this.pageInfo.ORGS != null && this.pageInfo.ORGS.length > 0) {
        this.infoEn = [];
        this.pageInfo.ORGS.forEach((item) => {
          item.id = this.infoEn.length;
          if (item.DOC_DATE != null && item.DOC_DATE.indexOf("-") != -1)
            item.DOC_DATE = dateConverter.fromServerConvert(item.DOC_DATE);
          this.infoEn.push(item);
        });
        this.doInBenefitsForFace[2] = true;
      }
      if (
        this.pageInfo.FOREIGN_ORGS != null &&
        this.pageInfo.FOREIGN_ORGS.length > 0
      ) {
        this.infoEnNo = [];
        this.pageInfo.FOREIGN_ORGS.forEach((item) => {
          item.id = this.infoEnNo.length;
          if (item.DOC_DATE != null && item.DOC_DATE.indexOf("-") != -1)
            item.DOC_DATE = dateConverter.fromServerConvert(item.DOC_DATE);

          this.infoEnNo.push(item);
        });
        this.doInBenefitsForFace[4] = true;
      }
      if (
        this.pageInfo.FOREIGN_PERSONS != null &&
        this.pageInfo.FOREIGN_PERSONS.length > 0
      ) {
        this.infoIndNo = [];
        if (this.pageInfo.PDMAN_SIBLING != null)
          this.relativeLevel = this.pageInfo.PDMAN_SIBLING;
        this.pageInfo.FOREIGN_PERSONS.forEach((item) => {
          item.id = this.infoIndNo.length;
          if (item.MIGRATION_CARD_NO != null) item.HAS_MIGRATION_CARD = true;
          else item.HAS_MIGRATION_CARD = false;
          if (item.DUL_DOCTYPE == null)
            item.DUL_DOCTYPE = "Паспорт гражданина РФ";
          if (item.BIRTH_DATE != null && item.BIRTH_DATE.indexOf("-") != -1)
            item.BIRTH_DATE = dateConverter.fromServerConvert(item.BIRTH_DATE);
          if (item.DUL_DATE != null && item.DUL_DATE.indexOf("-") != -1)
            item.DUL_DATE = dateConverter.fromServerConvert(item.DUL_DATE);
          if (item.DOC_DATE != null && item.DOC_DATE.indexOf("-") != -1)
            item.DOC_DATE = dateConverter.fromServerConvert(item.DOC_DATE);
          this.infoIndNo.push(item);
        });
        this.doInBenefitsForFace[5] = true;
      }
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
    } catch (error) {
      console.log(error);
    }
    this.validation();
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
.main-checkboxes {
  display: flex;
  flex-direction: column;
}
label {
  margin-left: 10px;
  margin-bottom: 5px;
}
.necessary {
  color: red;
}
.center-text {
  text-align: center;
}
.center-text-nes {
  color: red;
  text-align: center;
  font-size: 12px;
}
.afa-table {
  text-align: center;
  border-collapse: collapse;
  max-width: 100%;
  width: 100%;
  padding: 5px 0;
}
.afa-td {
  border: 1px solid black;
  padding: 5px 7px;
}
.input-line-textarea {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 100%;
  position: relative;
  resize: vertical;
  height: auto;
}
.input-line-textarea:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.add-button {
  float: left;
  padding: 10px 5px;
  text-align: center;
  cursor: pointer;
  color: #85b0f8;
  width: 100%;
}
.necessary-table-center {
  text-align: center;
  font-size: 12px;
}
.icons {
  background-color: white;
  border: none;
  color: #85b0f8;
  font-size: 15px;
}
.empty-space {
  height: 50px;
}
.droppdown-type {
  padding: 0;
  margin: 0;
}
.input-line {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 400px;
  position: relative;
}
.input-line:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
</style>
